// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page__RjX04 {
  display: flex;
  flex-grow: 1;
  background-color: #fbfbfb;
  align-items: stretch;
  min-height: 0;
  height: 100dvh;
  box-sizing: border-box;
}

.paletteContainer__j9yt9 {
  display: flex;
  width: 324px;
  flex-direction: column;
  background-color: white;
  border-radius: 16px;
  align-items: center;
  transition: width 0.3s ease-in-out;
}

.designDetailsPanel__VYfD7 {
  width: 820px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 16px;
  align-items: center;
  transition: width 0.3s ease-in-out;
}

.designContainer__Xu5AP {
  display: flex;
  position: relative;
  flex-grow: 1;
  background-color: white;
  height: 100%;
  border-top: 4px solid transparent;
  border-left: 4px solid transparent;
  border-right: 2px dashed var(--border-grey);
  box-sizing: border-box;
}

@media (max-width: 1100px) {
  .paletteContainer__j9yt9 {
    width: 225px;
  }
}

@keyframes border-shift__XE9gI {
  0% {
    border: 4px dashed rgba(255, 112, 112, 0.794);
  }
  50% {
    border: 4px dashed rgb(254, 238, 238);
  }
  100% {
    border: 4px dashed rgba(255, 112, 112, 0.794);
  }
}

.delete___PvVP {
  animation-name: border-shift__XE9gI;
  animation-timing-function: ease-in-out;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.toolbarContainer__oKR7z {
  position: absolute;
  bottom: 40px;
  left: calc(50% - 160px);
  height: 80px;
  width: 360px;
}

@media (max-width: 1350px) {
  .toolbarHidden__W3z7y {
    display: none;
  }
}

.warningModal__XaoYL {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-content: center;
  justify-content: center;
  padding: 0px 20px;
}
`, "",{"version":3,"sources":["webpack://./src/containers/design-app/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,iCAAiC;EACjC,kCAAkC;EAClC,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,qCAAqC;EACvC;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,mCAA4B;EAC5B,sCAAsC;EACtC,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;AACnB","sourcesContent":[".page {\n  display: flex;\n  flex-grow: 1;\n  background-color: #fbfbfb;\n  align-items: stretch;\n  min-height: 0;\n  height: 100dvh;\n  box-sizing: border-box;\n}\n\n.paletteContainer {\n  display: flex;\n  width: 324px;\n  flex-direction: column;\n  background-color: white;\n  border-radius: 16px;\n  align-items: center;\n  transition: width 0.3s ease-in-out;\n}\n\n.designDetailsPanel {\n  width: 820px;\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  border-radius: 16px;\n  align-items: center;\n  transition: width 0.3s ease-in-out;\n}\n\n.designContainer {\n  display: flex;\n  position: relative;\n  flex-grow: 1;\n  background-color: white;\n  height: 100%;\n  border-top: 4px solid transparent;\n  border-left: 4px solid transparent;\n  border-right: 2px dashed var(--border-grey);\n  box-sizing: border-box;\n}\n\n@media (max-width: 1100px) {\n  .paletteContainer {\n    width: 225px;\n  }\n}\n\n@keyframes border-shift {\n  0% {\n    border: 4px dashed rgba(255, 112, 112, 0.794);\n  }\n  50% {\n    border: 4px dashed rgb(254, 238, 238);\n  }\n  100% {\n    border: 4px dashed rgba(255, 112, 112, 0.794);\n  }\n}\n\n.delete {\n  animation-name: border-shift;\n  animation-timing-function: ease-in-out;\n  animation-duration: 2s;\n  animation-iteration-count: infinite;\n}\n\n.toolbarContainer {\n  position: absolute;\n  bottom: 40px;\n  left: calc(50% - 160px);\n  height: 80px;\n  width: 360px;\n}\n\n@media (max-width: 1350px) {\n  .toolbarHidden {\n    display: none;\n  }\n}\n\n.warningModal {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-content: center;\n  justify-content: center;\n  padding: 0px 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `page__RjX04`,
	"paletteContainer": `paletteContainer__j9yt9`,
	"designDetailsPanel": `designDetailsPanel__VYfD7`,
	"designContainer": `designContainer__Xu5AP`,
	"delete": `delete___PvVP`,
	"border-shift": `border-shift__XE9gI`,
	"toolbarContainer": `toolbarContainer__oKR7z`,
	"toolbarHidden": `toolbarHidden__W3z7y`,
	"warningModal": `warningModal__XaoYL`
};
export default ___CSS_LOADER_EXPORT___;
